(function () {
  function isLight() {
    return document.documentElement.getAttribute('data-theme') === 'light';
  }

  function labelFor(light) {
    return light ? 'Switch to dark mode' : 'Switch to light mode';
  }

  function sync(buttons) {
    var light = isLight();
    var label = labelFor(light);
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', light ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      var text = button.querySelector('.m-theme-toggle__label');
      if (text) text.textContent = label;
    });
  }

  function buttons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-theme-toggle]'));
  }

  function whenLightCssReady(done) {
    var link = document.querySelector('[data-theme-light]');
    if (!link || link.getAttribute('data-theme-ready') === 'true') {
      done();
      return;
    }
    link.media = 'all';
    if (link.sheet) {
      link.setAttribute('data-theme-ready', 'true');
      done();
      return;
    }
    link.addEventListener(
      'load',
      function () {
        link.media = 'all';
        link.setAttribute('data-theme-ready', 'true');
        done();
      },
      { once: true }
    );
  }

  function apply(theme) {
    var commit = function () {
      if (theme === 'light') {
        document.documentElement.setAttribute('data-theme', 'light');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }
      sync(buttons());
    };
    if (theme === 'light') whenLightCssReady(commit);
    else commit();
  }

  function bind() {
    var controls = buttons();
    sync(controls);
    controls.forEach(function (button) {
      if (button.getAttribute('data-theme-bound') === 'true') return;
      button.setAttribute('data-theme-bound', 'true');
      button.addEventListener('click', function () {
        apply(isLight() ? 'dark' : 'light');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
